<template>
  <div class="newDataPage">
    <div class="steps">
      <a-steps :current="current">
        <a-step v-for="item in steps" :key="item.title" :title="item.title" />
      </a-steps>
    </div>
    <div class="steps-content">
      <template v-if="current == 0">
        <new-customer @setFactory="setFactory" :customerInfo="customerInfo" ref="newCustomer"/>
      </template>
      <template v-if="current == 1">
        <new-feed-info 
          ref="newFeedInfo"
          @setFeedInfo="setFeedInfo" 
          :selectFactory="selectFactory" 
          :factoryId="factoryId"
          :feedVarietyList="feedVarietyList"
          :aquaticLineFishStockingInfoDetails="aquaticLineFishStockingInfoDetails"
          :aquaticLineFishFeedInfos="aquaticLineFishFeedInfos"
        />
      </template>
      <template v-if="current == 2">
        <new-harvest-info 
          ref="newHarvestInfo" 
          @setHarvestInfo="setHarvestInfo"
          :feedVarietyList="feedVarietyList"
          :aquaticLineFishProofingHarvestInfoDetails="aquaticLineFishProofingHarvestInfoDetails"
          :aquaticLineFishDieInfoDetails="aquaticLineFishDieInfoDetails"
        />
      </template>
      <template v-if="current == 3">
        <new-customer-feedback 
          ref="newCustomerFeedback" 
          @setFeedBack="setFeedBack"
          @setFileList="setFileList" 
          :aquaticLineFishFeedback="aquaticLineFishFeedback"
          :fileListProp="{fileList,videoFileList}"
        />
      </template>
      <template v-if="current ==4">
        <new-finish 
          :returnList="returnList" 
          :saveSuccess="saveSuccess" 
          :recordId="recordId"
          @saveData="'saveData'"
        />
      </template>
    </div>
    <div class="footer">
      <a-button v-if="current > 0 && current < steps.length-1" @click="prev">上一步</a-button>
      <a-button v-if="current == 0" @click="returnList">取 消</a-button>
      <a-button v-if="current < steps.length - 2" type="primary" @click="next" style="margin-left: 10px">下一步</a-button>
      <a-button v-if="current == 3" type="primary" @click="next" style="margin-left: 10px">提 交</a-button>
    </div>
    <calculation-result-modal 
      :visible="visible" 
      @isShow="isShow"
      :calculationResult="calculationResult"
      :calculationAbnormal="calculationAbnormal"
      @calculationAbnormalInit="calculationAbnormalInit"
      @confirm="calculationConfirm"
    />
    <confirmation-info-modal 
      :visible="visibleConfirmFeed" 
      :name="'放养信息'"
      :confirmResultList="aquaticLineFishStockingInfoList"
      :confirmResult="aquaticLineFishStockingInfo"
      @isShow="isShowFeed"
      @confirm="feedConfirm"
    />
    <confirmation-info-modal 
      :name="'打样/收获信息'"
      :confirmResultList="aquaticLineFishProofingHarvestInfoList"
      :confirmResult="aquaticLineFishProofingHarvestInfo"
      :visible="visibleConfirmHarvest" 
      @isShow="isShowHarvest"
      @confirm="harvestConfirm"
    />
    <variety-modal VarietyDepotCode="fish" />
    <Variety2Modal />
  </div>
</template>
<script>
import NewCustomer from './FishNewDataComponents/NewCustomer';
import NewCustomerFeedback from './FishNewDataComponents/NewCustomerFeedback.vue';
import NewFeedInfo from './FishNewDataComponents/NewFeedInfo.vue';
import NewHarvestInfo from './FishNewDataComponents/NewHarvestInfo.vue'
import NewFinish from './FishNewDataComponents/NewFinish';
import CalculationResultModal from './FishNewDataComponents/CalculationResultModal'
import ConfirmationInfoModal from './FishNewDataComponents/ConfirmationInfoModal';
import VarietyModal from './FishNewDataComponents/VarietyModal.vue';
import Variety2Modal from './FishNewDataComponents/Variety2Modal.vue';
import {aquaticLineFishStockingInfoList, aquaticLineFishProofingHarvestInfoList} from './FishNewDataComponents/Lists'
import api from '../EmpiricalData/api'
import { mapMutations,mapState } from 'vuex';
export default {
  components: { NewCustomer, NewFeedInfo, NewCustomerFeedback, NewFinish, CalculationResultModal, NewHarvestInfo, ConfirmationInfoModal,VarietyModal,Variety2Modal,},
  data() {
    return {
      current: 0,
      steps: [
        {title: '填写客户信息'},
        {title: '填写放养信息'},
        {title: '填写打样/收获信息'},
        {title: '填写客户反馈'},
        {title: '完成'},
      ],
      // aquaticLineFishStockingInfo:{},
      // aquaticLineFishProofingHarvestInfo:{},
      selectFactory:'',
      factoryId:'',
      customerInfo:{},
      // aquaticLineFishStockingInfoDetails:[],
      // aquaticLineFishFeedInfos:{},
      aquaticLineFishStockingInfoList,
      // aquaticLineFishProofingHarvestInfoDetails:[],
      aquaticLineFishProofingHarvestInfoList,
      // aquaticLineFishDieInfoDetails:[],
      // aquaticLineFishDieInfo:{},
      aquaticLineFishFeedback:{},
      uploadFiles:{},
      visible:false,
      visibleConfirmFeed:false,
      visibleConfirmHarvest:false,
      calculationResult:{},
      calculationAbnormal:[],
      settlementId:'',
      saveSuccess:false,
      recordId:'',
      fileList:[],
      videoFileList:[],
      stages2:[],
      stagesCode:[],
      Tipsmsg:'',
      flag1 : false,
      flag2 : false,
      msg1 :'',
      msg2 : '',
      feedVarietyList:[]
    };
  },
  computed: {
    ...mapState('empirical',[
      'aquaticLineFishStockingInfo',
      'aquaticLineFishProofingHarvestInfo',
      'aquaticLineFishDieInfo',
      'aquaticLineFishFeedInfos',
      'aquaticLineFishDieInfoDetails',
      'aquaticLineFishProofingHarvestInfoDetails',
      'aquaticLineFishStockingInfoDetails',
      'hasFish',
    ]),
  },
  async mounted(){
    await this.resetData()
    if(this.$route.query.copyId) this.copyValues()
  },
  methods: {
    ...mapMutations('empirical',['setState']),
    // 复制信息赋值
    async copyValues(){
      let {copyId} = this.$route.query
      let params = {
        recordId: copyId,
        lineType: 'AQUATIC_LINE_FISH'
      }
      let res = await api.pigDetail(params)
      if(!res.success) this.$message.error(res.msg) 
      let {
          stockingInfo,
          proofingHarvestInfo,
          dieInfo,
          feedInfoList,
          dieInfoDetailDTOList,
          proofingHarvestInfoDetailDTOList,
          stockingInfoDetailDTOList,
          feedback,
        } = res.data || {}
        dieInfoDetailDTOList = dieInfoDetailDTOList.map(el => {
          el.details = el.details.map(item => {
            delete item.id
            item.dieDate = el.dieDate
            return item
          })
          return el
        })
        proofingHarvestInfoDetailDTOList = proofingHarvestInfoDetailDTOList.map(el => {
          el.details = el.details.map(item => {
            delete item.id
            item.proofingHarvestDate = el.proofingHarvestDate
            return item
          })
          return el
        })
        stockingInfoDetailDTOList = stockingInfoDetailDTOList.map(el => {
          el.details = el.details.map(item => {
            delete item.id
            item.stockingDate = el.stockingDate
            return item
          })
          return el
        })
      delete stockingInfo.id
      delete proofingHarvestInfo.id
      delete dieInfo.id
      feedInfoList = feedInfoList.map(el => {
        delete el.id
        return el
      })
      this.getModelFishList(stockingInfoDetailDTOList)
      this.setState({
        aquaticLineFishStockingInfo: stockingInfo,
        aquaticLineFishProofingHarvestInfo: proofingHarvestInfo,
        aquaticLineFishDieInfo: dieInfo,
        aquaticLineFishFeedInfos: feedInfoList,
        aquaticLineFishDieInfoDetails: dieInfoDetailDTOList,
        aquaticLineFishProofingHarvestInfoDetails: proofingHarvestInfoDetailDTOList,
        aquaticLineFishStockingInfoDetails: stockingInfoDetailDTOList,
      })
      this.aquaticLineFishFeedback = feedback || {}
      this.customerInfo = res?.data?.customerInfo || {}
      // this.customerInfo.region = this.customerInfo.province&&this.customerInfo.city&&this.customerInfo.area ?
      //  [this.customerInfo.province,this.customerInfo.city,this.customerInfo.area] : undefined
      //  if(!(this.customerInfo.createUser == window.localStorage.getItem('staffId')) && this.poultryLineEggFeedInfo.feedBrand == '新希望'){
      //   this.poultryLineEggFeedInfo.productName = ''
      //   this.poultryLineEggFeedInfo.nhfFormulaId = ''
      //   this.poultryLineEggFeedInfo.modelCode = ''
      //   this.poultryLineEggFeedInfo.modelName = ''
      // }
      this.uploadFiles = res?.data?.uploadFiles || {}
      this.loadFiles()
    },
    getModelFishList(aquaticLineFishStockingInfoDetails){
      let lst = [],stockingFish = [],ids = [],stockingCSFish = []
      aquaticLineFishStockingInfoDetails.forEach(el => {
        lst = [...lst,...el.details]
      })
      lst.forEach(el => {
        if(!ids.includes(el.varietyId)){
          let a = JSON.parse(JSON.stringify(el))
          a.stockingSpecification = undefined
          a.stockingNum = undefined
          a.stockingWeight = undefined
          ids.push(a.varietyId)
          stockingFish.push(a)
        }
      })
      stockingCSFish = stockingFish.filter(el => el.varietyLabelCode === 'chishi')
      this.setState({stockingFish,stockingCSFish})
    },
    filterVariety(){
      let lst = [],stockingFish = [],ids = [],stockingCSFish = []
      this.aquaticLineFishStockingInfoDetails.forEach(el => {
        lst = [...lst,...el.details]
      })
      lst.forEach(el => {
        if(!ids.includes(el.varietyId)){
          let a = JSON.parse(JSON.stringify(el))
          a.stockingSpecification = undefined
          a.stockingNum = undefined
          a.stockingWeight = undefined
          ids.push(a.varietyId)
          stockingFish.push(a)
        }
      })
      stockingCSFish = stockingFish.filter(el => el.varietyLabelCode === 'chishi')
      this.setState({stockingFish,stockingCSFish: [...stockingCSFish]})
    },
    // 点击下一步回调
    next() {
      if(this.current == 0){
        this.$refs.newCustomer.form.validateFields((err, values) => {
          if (!err) {
            this.customerInfo = values
            if(this.hasFish){
              this.current++;
            }
          }
        })
      }
      else if(this.current == 1){
        // this.$refs.newFeedInfo.sendData()
        let errMsg = this.checkStockingList()
        if(errMsg){
          this.$message.warning(errMsg)
        }else{
          this.filterVariety()
          this.visibleConfirmFeed = true
        }
      }
      else if(this.current == 2){
        let errMsg = this.checkHarvesList()
        if(errMsg){
          this.$message.warning(errMsg)
        }else{
          this.visibleConfirmHarvest = true
        }
      }
      else if(this.current == 3){
        // 保存数据
        this.$refs.newCustomerFeedback.form.validateFields((err) => {
          if (!err) {
            this.$refs.newCustomerFeedback.sendData()
            this.saveData()
            // this.current++;
          }
        })
      }
    },
    checkStockingList(){
      let msg = ''
      if(this.aquaticLineFishStockingInfoDetails.length === 0) msg = '请选择放养品种'
      if(this.aquaticLineFishFeedInfos.length === 0) msg = '请添加用料信息'
      if(!msg){
        this.aquaticLineFishStockingInfoDetails.forEach(el => {
          if(!el.stockingDate) msg = '请选择放养日期'
          el.details.forEach(item => {
            if(
              (!item.stockingNum && item.stockingNum !== 0) ||
              !item.stockingSpecification && item.stockingSpecification !== 0 ||
              !item.stockingWeight && item.stockingWeight !== 0
            ){
              msg = '请完善放养数据'
            }
          })
        })
      }
      if(!msg){
        this.aquaticLineFishFeedInfos.forEach(el => {
          if(
              (!el.feedBrand) ||
              !el.productName ||
              !el.feedTerminalPrice && el.feedTerminalPrice !== 0 ||
              !el.feedCost && el.feedCost !== 0
            ){
              msg = '请完善用料信息数据'
            }
        })
      }
      return msg
    },
    checkHarvesList(){
      let msg = ''
      // aquaticLineFishProofingHarvestInfo,aquaticLineFishDieInfo
      if(this.aquaticLineFishProofingHarvestInfoDetails.length === 0) msg = '请选择打样/收获品种'
      if(this.aquaticLineFishDieInfoDetails.length === 0) msg = '请添加死鱼信息'
      if(!msg){
        this.aquaticLineFishProofingHarvestInfoDetails.forEach(el => {
          if(!el.proofingHarvestDate) msg = '请选择打样/收获日期'
          el.details.forEach(item => {
            if(
              (!item.proofingHarvestNum && item.proofingHarvestNum !== 0) ||
              !item.proofingHarvestWeight && item.proofingHarvestWeight !== 0
            ){
              msg = '请完善打样/收获数据'
            }
          })
        })
      }
      if(!msg){
        this.aquaticLineFishDieInfoDetails.forEach(el => {
          if(!el.dieDate) msg = '请选择死鱼信息日期'
          el.details.forEach(item => {
            if(
              (!item.dieNum && item.dieNum !== 0) ||
              !item.dieWeight && item.dieWeight !== 0
            ){
              msg = '请完善死鱼信息'
            }
          })
        })
      }
      return msg
    },
    // 点击上一步回调
    prev() {
      if(this.current == 1){
        this.$refs.newFeedInfo.form.validateFields((err, values) => {
          this.pigLineFeedInfo = values
          // this.$refs.newFeedInfo.sendData()
        })
      }
      else if(this.current == 2){
        // this.$refs.newHarvestInfo.sendData()
      }
      else if(this.current == 3){
        this.$refs.newCustomerFeedback.sendData()
      }
      this.current--;
    },
    // 获取品种列表
    async VarietyGet() {
      const res = await this.$http.get("/sat-ruminants/animalvariety/list?VarietyDepotCode",{VarietyDepotCode: 'fish'})
      // this.feedVarietyList.splice(0,this.feedVarietyList.length)
      this.feedVarietyList = res.data.records.map(item => {
        let varietyLabelCode = '',varietyLabelName = ''
        item.labels.forEach((el,index) => {
          varietyLabelCode = varietyLabelCode + (index > 0 ? `、${el.labelCode}` : el.labelCode)
          varietyLabelName = varietyLabelName + (index > 0 ? `、${el.labelName}` : el.labelName)
        })
        return {
          // ...item,
          varietyId: item.id,
          varietyName:item.name,
          varietyLabelCode,
          varietyLabelName,
          stockingSpecification: undefined,
          stockingNum: undefined,
          stockingWeight: undefined,
        }
      })
      this.setState({feedVarietyList: this.feedVarietyList})
    },
    // 弹窗开关
    isShow(val){
      this.visible = val
    },
    isShowFeed(val){
      this.visibleConfirmFeed = val
    },
    isShowHarvest(val){
      this.visibleConfirmHarvest = val
    },
    // 弹窗确认
    feedConfirm(){
      this.feedCheck()
    },
    harvestConfirm(){
      this.harvestCheck()
    },
    // 获取已选择工厂信息
    setFactory(value) {
      this.factoryId = value.factoryId
      this.selectFactory = value.selectFactory
      this.settlementId = value.settlementId
      this.settlementName = value.settlementName
      // this.VarietyGet()
    },
    // 获取打样/收获信息
    setHarvestInfo() {
      
    },
    // 获取放养信息
    setFeedInfo() {
      
    },
    // 获取用户反馈
    setFeedBack(value) {
      this.aquaticLineFishFeedback = value
    },
    // 获取已上传媒体文件列表
    setFileList(value){
      this.fileList = value.fileList
      this.videoFileList =value.videoFileList
    },
    resetData(){
      this.setState({
        detail: {},
        feedVarietyList: [], // 品种
        varietyVisible: false,
        variety2Visible: false,
        tabKey: 0,
        paneType: '', // 绑定tabs 的key
        varietySelect: [], // 选中品种
        dateField: '', // 日期字段
        varietyDate: null, // 选中日期
        varietyType: '', // 当前选择鱼的类型
        stockingFish: [], // 放养的鱼的品种
        aquaticLineFishStockingInfo: {}, // 鱼类放养基本信息
        aquaticLineFishStockingInfoDetails: [{stockingDate: null,details: []}], // 鱼类放养列表
        aquaticLineFishFeedInfos: [], // 用料信息
        aquaticLineFishProofingHarvestInfo: {}, // 打样基本信息
        aquaticLineFishProofingHarvestInfoDetails: [{proofingHarvestDate: null,details: []}], // 打样列表
        aquaticLineFishDieInfo: {}, // 死鱼信息
        aquaticLineFishDieInfoDetails: [{dieDate: null,details: []}], // 死鱼列表
      })
    },
    // 返回列表
    returnList(){
      this.resetData()
      this.$router.push({
        path: '/empirical-data/aquatic',
        query:{
          name: '水产线路',
        }
      })
    },
    feedCheck(){
      //校验规则
      this.current++
    },
    harvestCheck(){
      //校验规则
      this.getCalculationResult()
    },
    // 计算结果
    async getCalculationResult(){
      const res = await this.$http.post("/sat-collect/aquaticLine/fish/calculate", { 
        aquaticLineFishCustomerInfo:{
          ...this.customerInfo,
          province:this.customerInfo.region ? this.customerInfo.region[0] : undefined,
          city:this.customerInfo.region ? this.customerInfo.region[1] : undefined,
          area:this.customerInfo.region ? this.customerInfo.region[2] : undefined,
          factoryId:this.factoryId,
          settlementId:this.settlementId,
          settlementName:this.settlementName
        },
        aquaticLineFishStockingInfo:this.aquaticLineFishStockingInfo,
        aquaticLineFishFeedInfos:this.aquaticLineFishFeedInfos,
        aquaticLineFishProofingHarvestInfo:this.aquaticLineFishProofingHarvestInfo,
        aquaticLineFishDieInfo:this.aquaticLineFishDieInfo
      })
      let { msg,success,data } = res
      if(data) this.calculationResult = data 
      if(!success) this.calculationAbnormal = msg.split(",")
      this.visible = true
    },
    calculationConfirm(){
      this.current++;
    },
    calculationAbnormalInit(){
      this.calculationAbnormal = []
    },
    
    timesData(){
      let aquaticLineFishDieInfoDetails = [],
      aquaticLineFishProofingHarvestInfoDetails = [],
      aquaticLineFishStockingInfoDetails = []
      this.aquaticLineFishDieInfoDetails.forEach(el => {
        aquaticLineFishDieInfoDetails = [...aquaticLineFishDieInfoDetails,...el.details]
      })
      this.aquaticLineFishProofingHarvestInfoDetails.forEach(el => {
        aquaticLineFishProofingHarvestInfoDetails = [...aquaticLineFishProofingHarvestInfoDetails,...el.details]
      })
      this.aquaticLineFishStockingInfoDetails.forEach(el => {
        aquaticLineFishStockingInfoDetails = [...aquaticLineFishStockingInfoDetails,...el.details]
      })
      return {aquaticLineFishDieInfoDetails,aquaticLineFishProofingHarvestInfoDetails,aquaticLineFishStockingInfoDetails}
    },
    // 保存
    async saveData(){
      let listData = this.timesData()
      let params = {
        lineType:'AQUATIC_LINE_FISH',
        ...listData,
        aquaticLineFishCustomerInfo:{
          ...this.customerInfo,
          province:this.customerInfo.region ? this.customerInfo.region[0] : undefined,
          city:this.customerInfo.region ? this.customerInfo.region[1] : undefined,
          area:this.customerInfo.region ? this.customerInfo.region[2] : undefined,
          factoryId:this.factoryId,
          settlementId:this.settlementId,
          settlementName:this.settlementName,
        },//客户基础信息
        aquaticLineFishStockingInfo:this.aquaticLineFishStockingInfo,//放养信息
        // aquaticLineFishStockingInfoDetails:this.aquaticLineFishStockingInfoDetails,//放养信息详情
        aquaticLineFishFeedInfos:this.aquaticLineFishFeedInfos,//用料信息
        // aquaticLineFishProofingHarvestInfoDetails:this.aquaticLineFishProofingHarvestInfoDetails,//打样/收获详情信息详情
        aquaticLineFishProofingHarvestInfo:this.aquaticLineFishProofingHarvestInfo,//打样/收获信息
        aquaticLineFishDieInfo:this.aquaticLineFishDieInfo,//死鱼信息
        // aquaticLineFishDieInfoDetails:this.aquaticLineFishDieInfoDetails,//死鱼信息详情
        aquaticLineFishProductResult:this.calculationResult,//计算结果
        aquaticLineFishFeedback:this.aquaticLineFishFeedback,//客户反馈信息
        uploadFiles: this.aquaticLineFishFeedback.uploadFiles//上传的媒体文件
      }
      const res = await this.$http.post("/sat-collect/aquaticLine/fish/save", params)
      this.saveSuccess = res.success
      if(res.success) this.recordId = res.data.aquaticLineFishCustomerInfo.id
      this.current++
    },
    // 媒体文件
    loadFiles() {
      this.fileList = []
      this.videoFileList = []
      this.uploadFiles?.forEach(item => {
        const fileName = item.fileName
        const arr = fileName.split("/")
        const name = arr[arr.length-1]
        this.$http.get('/sat-collect/upload/getFileUrlList',{ params:{fileName} }).then(res =>{
          if(item.mediaType == 'PIC'){
            this.fileList.push({
              uid :item.id,
              url : res.data,
              fileName : fileName,
              name : name
            })
          }
          if(item.mediaType == 'VIDEO'){
            this.videoFileList.push({
              uid :item.id,
              url : res.data,
              fileName : fileName,
              name : name
            })
          }
        })
      })
    }
  },
};
</script>

<style lang='scss'>
.newDataPage{
  background-color: #fff;
  margin-top: 20px;
  // .ant-form-item-label{
  //   line-height: 20px
  // }
  .ant-form-explain{
    margin-top: -2px;
  }
}
.steps{
  padding: 30px;
}
.footer{
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 8px;
  background: #fff;
  text-align: center;
  z-index: 1;
  .ant-btn{
    font-size: small !important
  }
}
</style>